/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { DictionaryEntryDto } from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class TaskTypeController<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags task-type-controller
   * @name ApiV1TaskTypesViewsDictionaryUsingGet
   * @summary viewDictionary
   * @request GET:/api/v1/task-types/views/dictionary
   * @secure
   */
  apiV1TaskTypesViewsDictionaryUsingGet = (params: RequestParams = {}) =>
    this.request<DictionaryEntryDto[], void>({
      path: `/api/v1/task-types/views/dictionary`,
      method: "GET",
      secure: true,
      ...params,
    });
}
